import "./src/css/index.css";
import "@fontsource/poppins"

export const onRouteUpdate = () => {
    window.rudderanalytics && window.rudderanalytics.page();

};
